export class CurrencyLog {
    Id: number;
    SystemCurrencyId: number;
    CurrencyCode: string;
    CurrencyValue: number;
    StatementId: number;
}
